export function isRetryableError(error) {
  if (error == null) return false;

  if (typeof error === "string") {
    const message = error.toLowerCase();
    return (
      message.includes("internet") ||
      message.includes("connect") ||
      message.includes("timeout") ||
      message.includes("network")
    );
  }

  if (typeof error === "object") {
    const message = String(
      error.message || error.error || error.response || ""
    ).toLowerCase();
    const code = error.code ?? error.status;

    return (
      code === 0 ||
      message.includes("internet") ||
      message.includes("connect") ||
      message.includes("timeout") ||
      message.includes("network")
    );
  }

  return false;
}

export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
